import React, { useState } from "react";

import { SlideContainer, SlideContent } from "./styles";

// Hint: Most of the props are only used in the containers, e.g. key.
export type SlideProps = {
  key: string;
  meta?: { title?: string };
  isActive?: boolean;
  backgroundImageUrl?: string;
  backgroundColor?: string;
  children: React.ReactNode;
};

const Slide: React.FC<SlideProps> = (props: SlideProps): React.JSX.Element => {
  const { isActive, children } = props;
  const [showSlide, setShowSlide] = useState<boolean>(false);
  if (!showSlide && isActive) {
    // Once the slide was active, the slide is released (mounted)
    setShowSlide(true);
  }

  return (
    <SlideContainer $isActive={isActive} data-qa="slider:slide">
      {showSlide && <SlideContent>{children}</SlideContent>}
    </SlideContainer>
  );
};

export default Slide;
